import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Mail } from "lucide-react";

export default function EmailsPage() {
  const [items, setItems] = useState([]);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/emails");
      setItems(data);
      if (data[0]) setSelected(data[0]);
    })();
  }, []);

  return (
    <div className="space-y-6" data-testid="emails-page">
      <div>
        <p className="vv-label">Bandeja de salida</p>
        <h1 className="text-3xl font-semibold tracking-tight mt-1">Correos enviados</h1>
        <p className="text-sm text-gray-500 mt-1">Historial de mensajes de reserva. Por ahora los envíos son simulados.</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        <div className="vv-card overflow-hidden lg:col-span-1 max-h-[70vh] overflow-y-auto">
          {items.length === 0 ? (
            <div className="p-12 text-center text-sm text-gray-500">Sin correos enviados.</div>
          ) : items.map((m) => (
            <button
              key={m.id}
              onClick={() => setSelected(m)}
              className={`w-full text-left px-4 py-3 border-b border-[var(--vv-border)] hover:bg-gray-50 ${selected?.id === m.id ? "bg-blue-50" : ""}`}
            >
              <div className="flex items-center justify-between">
                <div className="text-xs text-gray-500 mono">{m.to_email}</div>
                <div className="text-[10px] text-gray-400">{m.created_at?.slice(0, 16).replace("T", " ")}</div>
              </div>
              <div className="text-sm font-medium mt-1 truncate">{m.subject}</div>
              <div className="text-xs text-gray-500 mt-1 line-clamp-2">{m.body}</div>
            </button>
          ))}
        </div>

        <div className="vv-card p-6 lg:col-span-2 min-h-[70vh]">
          {selected ? (
            <div>
              <div className="text-xs text-gray-500 mb-1">Para: <span className="text-gray-900 mono">{selected.to_email}</span></div>
              {selected.cc && <div className="text-xs text-gray-500 mb-1">CC: <span className="text-gray-900 mono">{selected.cc}</span></div>}
              <div className="text-xl font-semibold tracking-tight mt-1 mb-5">{selected.subject}</div>
              <pre className="font-sans text-[13px] leading-relaxed whitespace-pre-wrap text-gray-800">{selected.body}</pre>
              <div className="mt-6 text-[11px] text-gray-400">Enviado vía {selected.sent_via} · estado {selected.status}</div>
            </div>
          ) : (
            <div className="h-full flex items-center justify-center text-sm text-gray-500">
              <div className="text-center">
                <Mail className="mx-auto mb-2" size={28} strokeWidth={1.5}/>
                Selecciona un correo
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
